var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOops(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.548,
    height: 186.727,
    viewBox: "0 0 145.548 186.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-521.698 -311.428)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.429,
    cy: 72.429,
    r: 72.429,
    transform: "translate(521.698 353.296)",
    fill: "#ffc84b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.143,490.3A77.85,77.85,0,0,1,521.9,441.452a72.428,72.428,0,0,0,144.5,0A77.849,77.849,0,0,1,594.143,490.3Z",
    transform: "translate(-0.016 -10.623)",
    fill: "#ffa83a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560.797 405.396)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 15.823,
    y2: 15.823,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6.883
  }), /*#__PURE__*/React.createElement("line", {
    y1: 15.823,
    x2: 15.823,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6.883
  }), /*#__PURE__*/React.createElement("line", {
    x2: 15.823,
    y2: 15.823,
    transform: "translate(50.836)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6.883
  }), /*#__PURE__*/React.createElement("line", {
    y1: 15.823,
    x2: 15.823,
    transform: "translate(50.836)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6.883
  })), /*#__PURE__*/React.createElement("path", {
    d: "M604.883,458.524v14.092a8.638,8.638,0,0,0,17.276,0v-7.48A36.252,36.252,0,0,0,604.883,458.524Z",
    transform: "translate(-6.796 -12.018)",
    fill: "#ea4840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.531,469.29c14.644-9.11,37.691-9.223,51.5,0",
    transform: "translate(-4.153 -12.336)",
    fill: "none",
    stroke: "#ffa83a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6.883
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(598.086 446.506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.159,465.136a36.252,36.252,0,0,0-17.276-6.612v7.333a36.244,36.244,0,0,1,17.276,6.613Z",
    transform: "translate(-604.883 -458.524)",
    fill: "#c6352f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M572.531,468.953a36.416,36.416,0,0,1,51.5,0",
    transform: "translate(-4.153 -11.999)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6.883
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.042,
    cy: 15.01,
    rx: 31.042,
    ry: 15.01,
    transform: "translate(563.085 359.07)",
    fill: "#ffe466"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(522.885 311.428)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.953 10.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M657.507,339.354l-.009.188-.006.1c0,.039,0,.071-.013.162-.017.157-.041.34-.076.545a6.313,6.313,0,0,1-1.253,2.6c-1.462,1.87-4.048,3.507-7.43,4.9a70.751,70.751,0,0,1-12.478,3.625c-4.878,1.008-10.419,1.829-16.476,2.471-3.026.344-6.187.591-9.455.855q-2.453.187-4.988.326c-1.69.1-3.4.2-5.144.276s-3.5.132-5.29.186-3.594.1-5.423.121c-3.657.03-7.394.04-11.194-.068a200.288,200.288,0,0,1-23.4-1.807,81.063,81.063,0,0,1-11.912-2.547,28.848,28.848,0,0,1-5.83-2.434,11.788,11.788,0,0,1-2.709-2.075,6.693,6.693,0,0,1-1.113-1.554l-.21-.468c-.061-.163-.115-.332-.169-.5s-.081-.349-.118-.524l-.033-.269-.015-.136a1.437,1.437,0,0,1-.014-.216l-.006-.386c.014-.2.032-.42.061-.618.034-.174.068-.351.11-.523l.155-.5a7.046,7.046,0,0,1,.936-1.723,12.432,12.432,0,0,1,2.483-2.481,30.051,30.051,0,0,1,5.571-3.285,77.1,77.1,0,0,1,11.674-4.165q2.944-.825,5.887-1.5t5.874-1.213c3.9-.732,7.783-1.308,11.6-1.778,3.825-.452,7.593-.821,11.289-1.057q2.773-.186,5.485-.306c.932-.045,1.781-.067,2.689-.1l2.67-.065c3.528-.045,6.962-.012,10.283.129,3.32.126,6.525.386,9.6.669,3.073.306,6.011.691,8.8,1.122,2.786.446,5.422.94,7.888,1.483s4.764,1.131,6.876,1.764a56.55,56.55,0,0,1,5.76,2.021,30.809,30.809,0,0,1,4.523,2.3,12.787,12.787,0,0,1,3.093,2.647,6.51,6.51,0,0,1,1.328,2.614,5.293,5.293,0,0,1,.113.813l.016.278Zm-3.336.017a3.465,3.465,0,0,0-.075-.382,3.117,3.117,0,0,0-.726-1.162,9.36,9.36,0,0,0-2.328-1.728,24.077,24.077,0,0,0-4.034-1.722,67.718,67.718,0,0,0-12.093-2.627c-2.394-.332-4.961-.6-7.675-.821s-5.576-.4-8.567-.519c-2.99-.151-6.111-.2-9.342-.253s-6.573-.051-10.009-.007l-2.589.035-2.636.058q-2.645.058-5.352.173c-3.606.166-7.29.361-11.026.675a196.271,196.271,0,0,0-22.843,3.058,77.031,77.031,0,0,0-11.267,3.11,26.584,26.584,0,0,0-5.084,2.46,9.243,9.243,0,0,0-1.954,1.636,3.977,3.977,0,0,0-.6.89l-.091.219-.068.216a.593.593,0,0,1-.039.134l-.024.374c0-.142,0-.008,0-.027l0,.054v.109l.029.22.055.227.081.233a3.866,3.866,0,0,0,.582.956,9.162,9.162,0,0,0,1.979,1.755,26.659,26.659,0,0,0,5.166,2.627,56,56,0,0,0,5.648,1.867c1.917.532,3.851,1,5.8,1.4a154.223,154.223,0,0,0,23.192,2.815c3.793.178,7.529.282,11.185.253q2.742-.012,5.423-.084c1.786-.051,3.549-.136,5.288-.228s3.453-.2,5.139-.339,3.344-.3,4.973-.474c3.259-.331,6.392-.789,9.39-1.26,3-.489,5.851-1.043,8.548-1.631s5.233-1.238,7.591-1.91a71.505,71.505,0,0,0,11.8-4.333,26.712,26.712,0,0,0,3.852-2.279,9.214,9.214,0,0,0,2.138-2.077,3.028,3.028,0,0,0,.558-1.3.291.291,0,0,1,.006-.1.373.373,0,0,0,0-.093v-.2Z",
    transform: "translate(-532.74 -323.406)",
    fill: "#e9f0f8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.183 10.343)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.674,
    cy: 4.674,
    r: 4.674,
    transform: "translate(0 7.013) rotate(-48.598)",
    fill: "#e9f0f8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.319 35.241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.691,354.005a4.5,4.5,0,1,1-4.788-4.191A4.5,4.5,0,0,1,634.691,354.005Z",
    transform: "translate(-625.702 -349.804)",
    fill: "#e9f0f8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.768 12.315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.106,344.5l-.023.172-.014.1c0,.036-.007.065-.024.148-.028.143-.065.309-.113.495a5.825,5.825,0,0,1-1.357,2.295c-1.491,1.607-4,2.911-7.221,3.933A65.313,65.313,0,0,1,632.587,354c-4.568.546-9.731.869-15.356.987-2.812.08-5.74.061-8.769.047q-2.271-.018-4.616-.089c-1.562-.044-3.149-.082-4.756-.148s-3.235-.152-4.883-.242-3.316-.188-5-.312c-3.367-.258-6.808-.541-10.3-.938a185.062,185.062,0,0,1-21.4-3.491,74.974,74.974,0,0,1-10.764-3.276,26.642,26.642,0,0,1-5.175-2.7,10.89,10.89,0,0,1-2.332-2.121,6.176,6.176,0,0,1-.9-1.517l-.157-.448c-.043-.155-.08-.314-.117-.473s-.048-.327-.068-.491l-.01-.251,0-.126a1.446,1.446,0,0,1,0-.2l.025-.355c.028-.188.062-.384.1-.565.045-.158.09-.318.142-.473l.182-.447a6.511,6.511,0,0,1,1-1.512,11.47,11.47,0,0,1,2.479-2.09,27.733,27.733,0,0,1,5.385-2.588,71.233,71.233,0,0,1,11.069-2.921q2.773-.529,5.536-.92t5.5-.658c3.651-.368,7.265-.6,10.819-.729a202.043,202.043,0,0,1,20.489.328c3.25.234,6.408.533,9.453.922s5.975.865,8.783,1.366c2.8.522,5.478,1.106,8.01,1.72s4.916,1.289,7.143,1.982a70.27,70.27,0,0,1,11.334,4.47,28.533,28.533,0,0,1,3.983,2.47,11.789,11.789,0,0,1,2.639,2.679,6.017,6.017,0,0,1,1.018,2.51,5.012,5.012,0,0,1,.04.757l-.007.257Zm-3.072-.246a3.079,3.079,0,0,0-.039-.357,2.892,2.892,0,0,0-.578-1.126A8.616,8.616,0,0,0,647.41,341a22.223,22.223,0,0,0-3.578-1.9,62.481,62.481,0,0,0-10.925-3.363c-2.177-.492-4.518-.944-7-1.355s-5.1-.8-7.844-1.148c-2.74-.371-5.609-.659-8.578-.962s-6.045-.56-9.211-.789l-2.385-.17-2.431-.153q-2.439-.153-4.94-.259c-3.332-.129-6.737-.237-10.2-.241a181.407,181.407,0,0,0-21.262,1.029,71.114,71.114,0,0,0-10.614,1.983,24.56,24.56,0,0,0-4.871,1.866,8.524,8.524,0,0,0-1.926,1.354,3.658,3.658,0,0,0-.621.771l-.1.195-.079.193a.564.564,0,0,1-.047.121l-.051.342c.011-.13,0-.007,0-.024l0,.05-.008.1.01.206.032.213.057.221a3.557,3.557,0,0,0,.461.925,8.467,8.467,0,0,0,1.684,1.771,24.63,24.63,0,0,0,4.549,2.821,51.757,51.757,0,0,0,5.052,2.16q2.583.959,5.224,1.741a142.38,142.38,0,0,0,21.124,4.4c3.477.46,6.907.848,10.274,1.107q2.525.2,5,.346c1.647.093,3.276.152,4.884.2s3.193.086,4.756.089,3.1-.015,4.614-.047c3.025-.05,5.943-.227,8.739-.426,2.8-.215,5.467-.5,7.995-.833s4.913-.731,7.136-1.164a66.039,66.039,0,0,0,11.2-3.066,24.593,24.593,0,0,0,3.723-1.8,8.532,8.532,0,0,0,2.13-1.745,2.788,2.788,0,0,0,.614-1.152.29.29,0,0,1,.014-.088.39.39,0,0,0,.01-.085l.008-.1.013-.174Z",
    transform: "translate(-537.984 -324.838)",
    fill: "#bac9db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.664)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.209,322.276a2.543,2.543,0,0,1-.276-.015l-9.431-.98a2.634,2.634,0,1,1,.545-5.239l9.431.98a2.634,2.634,0,0,1-.269,5.254Z",
    transform: "translate(-590.141 -316.029)",
    fill: "#bac9db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.295,325.831a2.634,2.634,0,0,1-2.1-4.214l2.881-3.838.414-3.99a2.634,2.634,0,0,1,5.239.545l-.565,5.44-3.756,5.006A2.633,2.633,0,0,1,594.295,325.831Z",
    transform: "translate(-591.663 -311.428)",
    fill: "#bac9db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.244,326.42a2.632,2.632,0,0,1-2.388-1.521l-2.646-5.67.565-5.441a2.634,2.634,0,0,1,5.239.545l-.414,3.99,2.029,4.349a2.635,2.635,0,0,1-2.385,3.748Z",
    transform: "translate(-595.21 -311.428)",
    fill: "#bac9db"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.954 17.211)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M666.823,340.422a2.318,2.318,0,0,1-.151-4.63l9.771-.65a2.317,2.317,0,1,1,.308,4.625l-9.772.65C666.927,340.42,666.874,340.422,666.823,340.422Z",
    transform: "translate(-664.507 -335.137)",
    fill: "#bac9db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.28 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.306,344.772a2.319,2.319,0,0,1-2.06-3.376l2.312-4.51-.283-4.245a2.317,2.317,0,1,1,4.625-.308l.368,5.526-2.9,5.651A2.317,2.317,0,0,1,669.306,344.772Z",
    transform: "translate(-666.99 -330.17)",
    fill: "#bac9db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M675.373,344.382a2.316,2.316,0,0,1-1.906-1l-3.621-5.218-.367-5.526a2.317,2.317,0,1,1,4.625-.308l.283,4.245,2.889,4.164a2.318,2.318,0,0,1-1.9,3.639Z",
    transform: "translate(-669.473 -330.169)",
    fill: "#bac9db"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 27.824)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.087,349.667a2.1,2.1,0,0,1-.138-4.191l6.514-.433a2.1,2.1,0,0,1,.278,4.186l-6.514.432C525.18,349.665,525.132,349.667,525.087,349.667Z",
    transform: "translate(-522.991 -345.038)",
    fill: "#bac9db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.742,352.568a2.1,2.1,0,0,1-1.864-3.056l1.472-2.87-.178-2.678a2.1,2.1,0,0,1,4.186-.278l.255,3.837-2,3.9A2.1,2.1,0,0,1,526.742,352.568Z",
    transform: "translate(-524.646 -341.727)",
    fill: "#bac9db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.788,352.307a2.094,2.094,0,0,1-1.725-.9l-2.5-3.6-.255-3.837a2.1,2.1,0,0,1,4.186-.278l.178,2.678,1.838,2.65a2.1,2.1,0,0,1-1.721,3.293Z",
    transform: "translate(-526.302 -341.727)",
    fill: "#bac9db"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.077 32.277)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.434,
    cy: 3.434,
    r: 3.434,
    transform: "matrix(0.981, -0.192, 0.192, 0.981, 0, 1.317)",
    fill: "#bac9db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.858 13.958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.754,330.718a4.382,4.382,0,1,1-4.662-4.081A4.382,4.382,0,0,1,643.754,330.718Z",
    transform: "translate(-635 -326.627)",
    fill: "#bac9db"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.822,
    cy: 4.495,
    rx: 0.822,
    ry: 4.495,
    transform: "translate(605.902 452.459)",
    fill: "#c6352f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops);
export default __webpack_public_path__ + "static/media/oops.8c2476613a08f9aa30f4acfebdcc092c.svg";
export { ForwardRef as ReactComponent };